<div class="" style="position: relative;">
    <span  [cpToggle]="true" [cpDialogDisplay]="'inline'" [colorPicker]="value" 
        (colorPickerChange)="onChangeColor($event);">
    </span>
    <button type="button" class="close btn-close" (click)="dismiss()" aria-label="Close">
        <img title="Close" src="./assets/images/icons/close.svg" />
      </button>
</div>